module.exports = function() {
	throw new Error("define cannot be used indirect");
};



//////////////////
// WEBPACK FOOTER
// ../~/webpack-stream/~/webpack/buildin/amd-define.js
// module id = 353
// module chunks = 0